import React from 'react'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="Footer">

    </footer>
  )
}
